export {
  compare,
  type Operation,
  applyPatch,
} from "./fast-json-patch/index.js";
